import React from 'react';
import style from './Backdrop.module.scss';

const Backdrop: React.FC = ({children}) => {
    return <div className={style.Backdrop}>
        {children}
    </div>;
}

export default Backdrop;